export default {
  data: () => ({
    refreshInterval: null,
    isPolling: false,
    svc: null,
  }),
  created() {
    this.init();
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    shouldPoll() {
      const video = this.model?.video;
      if (!video) return false;
      if (video.encoding_job) return true;
      if (!video.status) return false;
      return !["ACTIVE", "FAILED"].includes(video.status);
    },
    startPolling() {
      if (!this.refreshInterval && this.model?.id && this.shouldPoll()) {
        this.refreshInterval = setInterval(this.refreshStatus, 1000);
      }
    },
    stopPolling() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    resetPolling() {
      this.stopPolling();
      this.startPolling();
    },

    async refreshStatus() {
      if (this.model?.id && this.isPolling || !this.svc) return;
      if (!this.shouldPoll()) {
        this.stopPolling();
        return;
      }
      this.isPolling = true;
      try {
        this.model.video = await this.svc.getQuestionVideo(this.model.id);
        if (["ACTIVE", "FAILED"].indexOf(this.model.video?.status) !== -1) {
          this.stopPolling();
        }
      } catch (error) {
        console.error('Failed to refresh video status:', error);
      } finally {
        this.isPolling = false;
      }
    },
  }
}
